<template>
  <a
    :href="url"
    class="social-button"
    target="_blak"
    :class="{[`variant-${variant}`]: variant}"
  >
    <img
        :src="require(`@/assets/img/social/${variant}.svg`)"
        :alt="variant"
        class="icon"
    />
    <span class="text">{{ socialName }}</span>
  </a>
</template>

<script>
  export default {
    props: {
      variant: { type: String, default: null },
      url: { type: String, default: '#' }
    },
    computed: {
      socialName () {
        return this.variant.charAt(0).toUpperCase() + this.variant.slice(1)
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "~@/assets/sass/variables";

  .social-button {
    display: inline-flex;
    align-items: center;
    padding: 8px 24px;
    transition: .5s all;
    border-radius: 4px;
    border: 1px solid rgba(255, 255, 255, 0.10);

    .icon {
      margin-right: 12px;

      @media (max-width: $mobileBreakpoint) {
        margin-right: 0;
      }
    }
   
    @media (max-width: $mobileBreakpoint) {
      height: 36px;
      
      .text {
        display: none;
      }

      &:before {
        margin-right: 0;
      }
    }
  }
</style>